// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesPosesionSC = importAll(
  require.context('../../assets/posecionesycargoScz', true, /\.(png|jpe?g|svg)$/)
);